module.exports = __webpack_public_path__ + "static/media/fly0248.12320fe8.webp";